import React from 'react'
import { connect } from 'react-redux'
import KQQTModal from "../../BaoCaoDinhKy/KetQuaQuanTrac_BVMT/Modal"
import KQQTModal_DTM from "../../BaoCaoDinhKy/KetQuaQuanTrac/Modal"
import KQQTModal_HTMT from "../../BaoCaoDinhKy/KetQuaQuanTrac_HTMT/Modal"
import KQQTModal_NTTS from "../../BaoCaoDinhKy/KetQuaQuanTrac_NTTS/Modal"
import KQQTModal_VHL from "../../BaoCaoDinhKy/KetQuaQuanTrac_VHL/Modal"
class routerKQQTModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        }
    }

    render() {
        const { phanloai, initialValues, isOpen, handleCancel, idQuyetDinh, nam } = this.props
        return (
            <div>
                {phanloai === "BVMT" &&
                    <KQQTModal
                        mode="edit"
                        view="view"
                        initialValues={initialValues}
                        isOpen={isOpen}
                        handleCancel={handleCancel}
                        handleOk={() => { }}
                        isEdit={true}
                        idQuyetDinh={idQuyetDinh}
                    />}

                {phanloai === "DTM" &&
                    <KQQTModal_DTM
                        mode="edit"
                        view="view"
                        initialValues={initialValues}
                        isOpen={isOpen}
                        handleCancel={handleCancel}
                        handleOk={() => { }}
                        isEdit={true}
                        idQuyetDinh={idQuyetDinh}
                    />}
                {phanloai === "HTMT" &&
                    <KQQTModal_HTMT
                        mode="edit"
                        initialValues={initialValues}
                        isOpen={isOpen}
                        handleCancel={handleCancel}
                        handleOk={() => { }}
                        isEdit={true}
                        nam={nam}
                        view="view"
                    />}

                {phanloai === "NTTS" &&
                    <KQQTModal_NTTS
                        mode="edit"
                        initialValues={initialValues}
                        isOpen={isOpen}
                        handleCancel={handleCancel}
                        handleOk={() => { }}
                        isEdit={true}
                        nam={nam}
                        view="view"
                    />}

                {phanloai === "VHL" &&
                    <KQQTModal_VHL
                        mode="edit"
                        initialValues={initialValues}
                        isOpen={isOpen}
                        handleCancel={handleCancel}
                        handleOk={() => { }}
                        isEdit={true}
                        nam={nam}
                        view="view"
                    />}

            </div>
        )
    }
}

routerKQQTModal.propTypes = {

};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(routerKQQTModal)